"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createOrdinalQuestion = void 0;
const randomString_1 = require("./randomString");
function createOrdinalQuestion(settings, id = (0, randomString_1.randomString)(), template) {
    let choices;
    if (template && template.choices) {
        const tc = template.choices;
        choices = tc.map(c => ({
            id: (0, randomString_1.randomString)(),
            value: c.value,
            label: c.label,
        }));
    }
    if (!choices) {
        choices = [
            { id: (0, randomString_1.randomString)(), value: 1, label: "Option 1" },
            { id: (0, randomString_1.randomString)(), value: 2, label: "Option 2" },
        ];
    }
    return Object.assign({ id, questionType: "ordinal", templateId: template ? template.id : "", renderAs: template ? template.renderAs : undefined, allowComments: false, allowMultipleChoices: false, required: false, label: "", commentAppeal: "", choices }, settings);
}
exports.createOrdinalQuestion = createOrdinalQuestion;
//# sourceMappingURL=createOrdinalQuestion.js.map